import React, { useEffect, useState } from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const ExpenseListDetails = () => {
  const [expenses, setExpenses] = useState([]);

useEffect(() => {
    const fetchAccountDetails = async (accountId) => {
        try {
          const url = `${API_DOMAIN}${API_ROUTES.account}${accountId}/`;
          const token = localStorage.getItem('token');
          
          const response = await axios.get(url, { headers });

          return response.data.name;
        } catch (error) {
          console.error('Error fetching account details:', error);
        }
      };


    const fetchExpenses = async () => {
    try {
        const url = `${API_DOMAIN}${API_ROUTES.expense}`;
        const token = localStorage.getItem('token');
        
        const response = await axios.get(url, { headers });

        const expensesWithAccountDetails = await Promise.all(response.data.map(async (expense) => {
        const accountName = await fetchAccountDetails(expense.paid_from);
        return { ...expense, paid_from: accountName };
        }));

        setExpenses(expensesWithAccountDetails);
    } catch (error) {
        console.error('Error fetching expenses:', error);
    }
    };

    

    fetchExpenses();
  }, []);

  const columns = [
    { label: 'Date', value: 'date' },
    { label: 'Category', value: 'category' },
    { label: 'Amount', value: 'amount' },
    { label: 'Description', value: 'description' },
    { label: 'Paid From', value: 'paid_from' },
    { label: 'Payment Method', value: 'payment_method' },
  ];

  const handleViewDetails = (expenseId) => {
    //console.log('View Details', expenseId);
    const encodedId = btoa(expenseId);
    window.location.href = `/expense/details/${encodedId}`;
  };

  const actionButtons = [
    { label: 'View Details', handler: handleViewDetails },
  ];

  return <ListTemplate columns={columns} data={expenses} actionButtons={actionButtons} />;
};

export default ExpenseListDetails;